<template>
  <GuahaoPage />
</template>

<script>
import GuahaoPage from './views/GuahaoPage.vue'

export default {
  name: 'App',
  components: { GuahaoPage },
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  background-color: #24AAB6;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>
